import { useEffect } from "react";

import OrdersListContent from "./OrdersListContent";
import OrderTabHeader from "./OrderTabHeader";
import { OrderListSkeleton } from "./OrderSkeletons";

import { emptyCopy, errorCopy, orderPageSize, orderTabs } from "./order-list-utils";
import { useWindowWidth } from "../../../../hooks/use-breakpoint";
import { useOrdersList } from "../../../../features/orders/useOrdersList";
import { normalizeEnum } from "../../../../features/orders/orderStatus";

import {
  clearLocationState,
  GetLocationState,
} from "../../../../utils/common-utils";
import { getLabel } from "../../../../hooks/use-labels";

const OrdersList = () => {
  const locationState = GetLocationState();
  const { paramTab } = locationState || { paramTab: "" };

  const pageStep = orderPageSize(useWindowWidth());

  const {
    statusGroup,
    changeTab,
    rows,
    counts,
    isLast,
    showSkeleton,
    paginating,
    refreshing,
    refresh,
    loadMore,
    errorKind,
  } = useOrdersList(normalizeEnum(paramTab), pageStep);

  useEffect(() => {
    clearLocationState(locationState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sectionTitle =
    orderTabs.find((tab) => tab.key === statusGroup)?.label ||
    getLabel("myOrdersLabel");

  const empty = emptyCopy[statusGroup];

  return (
    <div className="ord-band">
      <OrderTabHeader
        activeTab={statusGroup}
        setActiveTab={changeTab}
        counts={counts}
      />

      <div className="ord-section-header">
        <h2 className="ord-section-title">{sectionTitle}</h2>

        <div className="ord-section-aside">
          {!showSkeleton && rows.length > 0 && (
            <p className="ord-results-count">{rows.length}</p>
          )}

          <button
            type="button"
            className="ord-refresh"
            disabled={refreshing}
            onClick={refresh}
          >
            {refreshing ? getLabel("loadingLabel") || "Refreshing…" : "Refresh"}
          </button>
        </div>
      </div>

      {showSkeleton ? (
        <OrderListSkeleton cards={pageStep} />
      ) : errorKind ? (
        <div className="ord-empty">
          <img
            src="/assets/icons/order/empty-order-placeholder.svg"
            alt=""
            aria-hidden="true"
          />

          <h2>{errorCopy[errorKind].heading}</h2>
          <p>{errorCopy[errorKind].body}</p>

          <div className="ord-empty-actions">
            <button type="button" className="ord-btn" onClick={refresh}>
              Try again
            </button>
          </div>
        </div>
      ) : !rows.length ? (
        <div className="ord-empty">
          <img
            src="/assets/icons/order/empty-order-placeholder.svg"
            alt=""
            aria-hidden="true"
          />

          <h2>{empty?.heading || getLabel("emptyOrderHeading")}</h2>
          {empty?.body && <p>{empty.body}</p>}
        </div>
      ) : (
        <OrdersListContent
          rows={rows}
          tab={statusGroup}
          loadingMore={paginating}
        />
      )}

      {!showSkeleton && !errorKind && !isLast && rows.length > 0 && (
        <div className="ord-more">
          <button
            type="button"
            className="ord-more-button"
            disabled={paginating}
            onClick={loadMore}
          >
            {paginating ? getLabel("loadingLabel") || "Loading…" : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
};

export default OrdersList;
